import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operationType'
})
export class OperationTypePipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case 1:
        return 'Create';
      case 2:
        return 'Update';
      case 3:
        return 'Delete';
      default:
        return 'Unknown';
    }
  }

}
